import { makeStyles } from '@material-ui/core/styles';
import { lightTokens } from '../theme/rafayTheme';
import { BrandIcon } from './BrandIcon';

const useStyles = makeStyles({
  textStack: {
    display: 'flex',
    flexDirection: 'column',
    lineHeight: 1.15,
    minWidth: 0,
  },
  brand: {
    fontSize: '1rem',
    fontWeight: 700,
    letterSpacing: '0.02em',
    whiteSpace: 'nowrap',
  },
  product: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
});

interface BrandMarkProps {
  size?: number;
  /** Icon only (collapsed sidebar), or icon + "RAFAY / Control Tower" text. */
  withText?: boolean;
  /** True on the sidebar (now a dark navy surface) — swaps the wordmark to
   * light-on-dark colors. False (default) everywhere else the mark is used
   * against a light surface (sign-in page, session-expired dialog). */
  light?: boolean;
}

export const BrandMark = ({
  size = 40,
  withText = false,
  light = false,
}: BrandMarkProps) => {
  const classes = useStyles();
  const iconSize = withText ? Math.round(size * 0.85) : size;

  if (!withText) {
    return <BrandIcon size={iconSize} />;
  }

  return (
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        minWidth: 0,
      }}
    >
      <BrandIcon size={iconSize} />
      <span className={classes.textStack}>
        <span
          className={classes.brand}
          style={{ color: light ? '#FFFFFF' : lightTokens.textPrimary }}
        >
          RAFAY
        </span>
        <span
          className={classes.product}
          style={{
            color: light
              ? lightTokens.sidebarMutedText
              : lightTokens.textSecondary,
          }}
        >
          Control Tower
        </span>
      </span>
    </span>
  );
};
